import React, { useState, useEffect, useContext } from "react";
import { Button, CircularProgress } from "@mui/material";
import Input from "@mui/joy/Input";
import Textarea from "@mui/joy/Textarea";
import { ThemeProvider } from "@emotion/react";
import axios from "axios";
import { useParams } from "react-router-dom";
import theme from "../../../themes/theme";
import { AppContext } from "../../../context/AppContext";
import BASE_URL from "../../../config/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../../components/AdminDashboard/AdminLayout/AdminLayout";

const EditLesson = () => {
  const { id, sectionId, lessonId } = useParams();
  const [lessonTitle, setLessonTitle] = useState("");
  const [lessonDescription, setLessonDescription] = useState("");
  const [lessonVideoUrl, setLessonVideoUrl] = useState("");
  const [lessonDuration, setLessonDuration] = useState("");
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AppContext);

  const fetchLessonDetails = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/courses/${id}/sections/${sectionId}/lessons/${lessonId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const lesson = response.data;
      setLessonTitle(lesson.title);
      setLessonDescription(lesson.description);
      setLessonVideoUrl(lesson.videoUrl);
      setLessonDuration(lesson.duration || "");
    } catch (err) {
      // console.error("Error fetching lesson details:", err.message);
    }
  };

  useEffect(() => {
    if (token) fetchLessonDetails();
  }, [token, id, sectionId, lessonId]);

  const handleUpdateLesson = async () => {
    try {
      setLoading(true);

      await axios.put(
        `${BASE_URL}/courses/${id}/sections/${sectionId}/lessons/${lessonId}`,
        {
          title: lessonTitle,
          description: lessonDescription,
          videoUrl: lessonVideoUrl,
          duration: lessonDuration,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Lesson updated successfully!");
      window.location.href = `/courses/${id}/sections`;

      setLoading(false);
    } catch (err) {
      toast.error("Failed to update lesson");
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <p className="title" style={{ fontSize: "1.7rem" }}>
        Update lesson details
      </p>
      <div className="lessons-wrapper">
        <div className="create-form-wrapper">
          <div className="lesson-form">
            <label>Lesson Title</label>
            <Input
              variant="soft"
              placeholder="Enter lesson title"
              value={lessonTitle}
              onChange={(e) => setLessonTitle(e.target.value)}
            />

            <label>Lesson Description</label>
            <Textarea
              minRows={4}
              variant="soft"
              placeholder="Enter lesson description"
              value={lessonDescription}
              onChange={(e) => setLessonDescription(e.target.value)}
            />

            <label>Video URL</label>
            <Input
              variant="soft"
              placeholder="Enter video URL"
              value={lessonVideoUrl}
              onChange={(e) => setLessonVideoUrl(e.target.value)}
            />

            <label>Lesson Duration</label>
            <Input
              variant="soft"
              placeholder="Enter lesson duration"
              value={lessonDuration}
              onChange={(e) => setLessonDuration(e.target.value)}
            />

            <ThemeProvider theme={theme}>
              <Button
                sx={{ marginTop: "10px" }}
                variant="contained"
                color="primary"
                onClick={handleUpdateLesson}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Update Lesson"}
              </Button>
            </ThemeProvider>
          </div>
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
      />
    </AdminLayout>
  );
};

export default EditLesson;
